import request from '@/utils/http.js';
import axios from 'axios';
import qs from 'qs';

// 获取自选股-历史选股
export function getFactorDetail(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getFactorDetail`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 获取云Token
export function getYunToken(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getYunToken`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 获取自选股-避险统计
export function getProfitStrategy(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getProfitStrategy`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 获取自选股-避险统计
export function getHedgingBackTest(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getHedgingBackTest`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 获取自选股-模拟走势
export function getHedgindSim(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getHedgindSim`,
    method: 'get',
    params,
    type: 'json'
  });
}

//  获取历史信号查询（含最新）分页
export function getHistoryPages(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getHistoryPages`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 获取用户的持仓股列表
export function getPostionStocks(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getPostionStocks`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 添加/编辑用户的持仓股
export function addPostionStock(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/addPostionStock`,
    method: 'get',
    params,
    type: 'json'
  });
}

//删除持仓股
export function delPostionStock(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/delPostionStock`,
    method: 'get',
    params,
    type: 'json'
  });
}


//查询大赛信息
export function myDsInfo(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/myDsInfo`,
    method: 'get',
    params,
    type: 'json'
  });
}

//查询大赛信息
export function getSignalList(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/getSignalList`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 解锁扣豆
export function signalUnLock(params = {}) {
  return request({
    url: `${window.config.api_v1}/Hedging/signalUnLock`,
    method: 'get',
    params,
    type: 'json'
  });
}